import { useMemo } from "react";
import type {
  Participant,
  ParticipantDisplayRole,
} from "@/react/types/Live/Participant";
import { formattedMessageSentAt } from "@circle-react/helpers/dateTimeHelpers/formattedMessageSentAt";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { TiptapEditor } from "@circle-react-uikit/TipTap";
import { Typography } from "@circle-react-uikit/Typography";
import { RoleIcon } from "../Participants/RoleIcon";

export interface MessageItemProps {
  message: any;
  participants: Participant[];
}

export const MessageItem = ({ message, participants }: MessageItemProps) => {
  const participant = useMemo(
    () =>
      participants.find(
        participant => participant.id === message.chat_room_participant_id,
      ),
    [participants, message.chat_room_participant_id],
  );
  const {
    created_at: createdAt,
    rich_text_body: richTextBody,
    embedded_chat_message_access: chatRoomAccessArr,
  } = message || {};

  const { avatar_url: avatarUrl, name, role } = participant || {};
  const { time } = formattedMessageSentAt(createdAt);

  if (!richTextBody) {
    return null;
  }
  return (
    <div className="flex w-[98%] max-w-full justify-start py-1.5">
      <div className="mr-3 pt-1">
        <UserImage src={avatarUrl} name={name || ""} size="10" />
      </div>
      <div className="w-full">
        <div className="flex items-center">
          <Typography.LabelSm weight="semibold" color="text-darkest">
            {name}
          </Typography.LabelSm>
          {role && <RoleIcon role={role as ParticipantDisplayRole} />}
          <span className="ml-2">
            <Typography.LabelXs color="text-light">{time}</Typography.LabelXs>
          </span>
        </div>
        <div className="text-dark mb-1 whitespace-pre-line text-sm font-normal">
          <TiptapEditor
            editable={false}
            rich_text_body={richTextBody}
            chatRoomAccessArr={chatRoomAccessArr}
          />
        </div>
      </div>
    </div>
  );
};
